import { render, staticRenderFns } from "./InvoicesArchive.vue?vue&type=template&id=2e35dc7d"
import script from "./InvoicesArchive.vue?vue&type=script&lang=js"
export * from "./InvoicesArchive.vue?vue&type=script&lang=js"
import style0 from "./InvoicesArchive.vue?vue&type=style&index=0&id=2e35dc7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports